import { render, staticRenderFns } from "./PrintItemHistory.vue?vue&type=template&id=683eaba3"
import script from "./PrintItemHistory.vue?vue&type=script&lang=js"
export * from "./PrintItemHistory.vue?vue&type=script&lang=js"
import style0 from "./PrintItemHistory.vue?vue&type=style&index=0&id=683eaba3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports